export default __webpack_public_path__ + "static/media/collabImg.7fee152a.png";